import request from '@/utils/request'

/**
 * 获取消息列表
 * @param {Object} param 请求参数
 * @param {String} param.noticeTitle 消息标题
 * @param {Number} param.pageNum 页码
 * @param {Number} param.pageSize 每页条数
 * @param {String} param.readStatus 阅读状态：0-未读,1-已读
 * @param {String} param.noticeType 消息类型
 * @param {String} param.createBy 创建人
 * @return {Promise<any>}
 */

export function getNoticeList({
  noticeTitle,
  pageNum = 1,
  pageSize = 1000,
  readStatus,
  noticeType,
  createTimeStart,
  createTimeEnd,
}) {
  return request({
    url: '/studentEnd/getNoticeList',
    method: 'post',
    data: {
      noticeTitle,
      pageNum,
      pageSize,
      readStatus,
      noticeType,
      createTimeStart,
      createTimeEnd,
    },
  })
}

/**
 * 获取消息信息详情
 * @param {Number} noticeId 消息ID
 * @return {Promise<any>}
 */

export function getNoticeDetail(noticeId) {
  return request({
    url: '/studentEnd/getNoticeDetail',
    method: 'post',
    data: {
      noticeId,
    },
  })
}

/**
 * 设置消息阅读状态
 * @param {Object} param 请求参数
 * @param {String} param.noticeIds 消息ID
 * @param {Number} param.readStatus 阅读状态：0-未读,1-已读
 * @return {Promise<any>}
 */

export function setNoticeReadStatus({ noticeIds, readStatus = '1' }) {
  return request({
    url: '/studentEnd/setNoticeReadStatus',
    method: 'post',
    data: {
      noticeIds,
      readStatus,
    },
  })
}

/**
 * 获取学生信息
 * @return {Promise<any>}
 */

export function getStudentInfo() {
  return request({
    url: '/studentEnd/getStudentInfo',
    method: 'post',
  })
}

/**
 * 获取教师信息
 * @return {Promise<any>}
 */

export function getTeacherInfo() {
  return request({
    url: `${window.location.origin}${import.meta.env.VITE_APP_TEACHER}api/teacherEnd/getTeacherInfo`,
    method: 'post',
  })
}

/**
 * 获取未读消息
 * @param {Object} param 请求参数
 * @param {Number} param.pageNum 页码
 * @param {Number} param.pageSize 每页条数
 * @param {String} param.keyword 关键字
 * @return {Promise<any>}
 */

export function getUnreadNoticeList({ pageNum = 1, pageSize = 10, keyword }) {
  return request({
    url: '/studentEnd/getUnreadNoticeList',
    method: 'post',
    data: {
      pageNum,
      pageSize,
      keyword,
    },
  })
}

/**
 * 修改头像
 * @return {Promise<any>}
 */

export function modifyAvatar(name) {
  return request({
    url: '/studentEnd/modifyAvatarImagePath',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      imagePath: name,
    },
  })
}

/**
 * 修改密码
 * @param {Object} param 请求参数
 * @param {String} param.newPassword 新密码
 * @param {String} param.oldPassword 旧密码
 * @return {Promise<any>}
 */

export function modifyPassword({ newPassword, oldPassword }) {
  return request({
    url: '/studentEnd/modifyPassword',
    method: 'post',
    data: {
      newPassword,
      oldPassword,
    },
  })
}

/**
 * 获取邮箱验证码
 * @param {String} email 邮箱地址
 * @return {Promise<any>}
 */
export function getRegisterEmailCode(email) {
  return request({
    url: '/sendEmailVcForRegister',
    method: 'post',
    data: {
      username: email,
    },
  })
}

//
// 获取邮箱验证码
// @param {String} email 邮箱地址
// @return {Promise}
//
export function getResetEmailCode(email) {
  return request({
    url: '/sendEmailVcForRetrievePassword',
    method: 'post',
    data: {
      username: email,
    },
  })
}

/**
 * @param {any} email
 * @param {any} password
 * @param {any} code
 */
export function retrievePassword(email, password, code) {
  return request({
    url: '/retrievePassword',
    method: 'post',
    data: {
      username: email,
      password,
      code,
    },
  })
}

/**
 * 注册用户
 * @param {string} email 用户邮箱
 * @param {string} password 用户密码
 * @param {string} code 验证码
 * @returns {Promise<any>}
 */
export function registerUser(email, password, code) {
  return request({
    url: '/register',
    method: 'post',
    data: {
      username: email,
      password,
      code,
    },
  })
}

/**
 * 修改手机号码
 * @param {String} phoneNumber 手机号码
 * @return {Promise<any>}
 */

export function modifyPhoneNumber(phoneNumber) {
  return request({
    url: '/studentEnd/modifyPhoneNumber',
    method: 'post',
    data: {
      phoneNumber,
    },
  })
}

/**
 * 获取学校配置信息
 * @return {Promise<any>}
 */
export function getSchoolConfig() {
  return request({
    url: '/studentEnd/getSchoolConfig',
    method: 'post',
  })
}

/**
 * 绑定兑换码
 * @param {String} redeemCode 兑换码
 * @param {String} remark 备注
 * @return {Promise<any>}
 */
export function bindRedeemCode(redeemCode, remark = '') {
  return request({
    url: '/studentEnd/bindBookRedeem',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      redeemCode,
      remark,
    },
  })
}
